<template>
  <v-row class="pa-5" v-if="exercise">
    <v-col cols="12">
      <h2>Service design</h2>
    </v-col>
    <v-col cols="12">
      <SaveCanvas>
        <div class="service">
          <div class="service__col">
            <p>Awareness</p>
            <service-card
              class="list-group-item"
              v-for="element in exercise.list1"
              :key="`awareness-${element.id}`"
              :card="element"
              :all="all"
              @showNote="showNote"
              :isOpen="true"
            >
            </service-card>
          </div>
          <div class="service__col">
            <p>First interaction</p>
            <service-card
              class="list-group-item"
              v-for="element in exercise.list2"
              :key="`awareness-${element.id}`"
              :card="element"
              :all="all"
              @showNote="showNote"
              :isOpen="true"
            >
            </service-card>
          </div>
          <div class="service__col">
            <p>Engagement</p>
            <service-card
              class="list-group-item"
              v-for="element in exercise.list3"
              :key="`awareness-${element.id}`"
              :card="element"
              :all="all"
              @showNote="showNote"
              :isOpen="true"
            >
            </service-card>
          </div>
          <div class="service__col">
            <p>Return</p>
            <service-card
              class="list-group-item"
              v-for="element in exercise.list4"
              :key="`awareness-${element.id}`"
              :card="element"
              :all="all"
              @showNote="showNote"
              :isOpen="true"
            >
            </service-card>
          </div>
          <div class="service__col">
            <p>Ambassadors</p>
            <service-card
              class="list-group-item"
              v-for="element in exercise.list5"
              :key="`awareness-${element.id}`"
              :card="element"
              :all="all"
              @showNote="showNote"
              :isOpen="true"
            >
            </service-card>
          </div>
        </div>
      </SaveCanvas>
    </v-col>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-text class="pa-10">
          <service-show :id="cardId" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { ServiceCard, ServiceShow } from "@/views/user/exercises/service";
import { mapState } from "vuex";
import { SaveCanvas } from "@/components/core";

export default {
  name: "ResultsSwotSummary",
  data() {
    return {
      doc: null,
      items: [],
      cardId: null,
      all: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      filters: [],
      exercise: null,
      dialog: false,
    };
  },
  props: {
    uid: String,
    id: String,
  },
  mounted() {
    this.loadNotes();
  },
  components: {
    ServiceCard,
    ServiceShow,
    SaveCanvas,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    loadNotes() {
      console.log("load notes");
      let ref = fb.exServiceNotesCollection.where("pid", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.all = items;
          }
          this.getExercise();
        })
        .catch(function() {});
    },
    getExercise() {
      console.log("get exercise");
      let ref = fb.serviceExCollection
        .where("pid", "==", this.id)
        .where("uid", "==", "shared");
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
          console.log("type", querySnapshot.docChanges()[0].type);
          this.list1 = [...doc.list1];
          this.list2 = [...doc.list2];
          this.list3 = [...doc.list3];
          this.list4 = [...doc.list4];
          this.list5 = [...doc.list5];
          this.ids = [...doc.ids];
        });
        this.exercise = items[0];
      });
    },
    showNote($event) {
      console.log("show note", $event);
      this.cardId = $event;
      this.dialog = true;
    },
    filterListType(list) {
      const match = list.filter((x) => x.categories.includes(this.filters));
      console.log("match", match);
    },
  },
};
</script>
